module.exports = __webpack_public_path__ + "static/media/1.27e71a0e.png";